import { Component, OnInit, ViewChild } from '@angular/core';
import { ClassWebsites } from 'src/app/model/classWebsites'
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ClassWebsitesJson } from '../../plainData/classWebsite'
import { map } from 'rxjs/operators';


@Component({
  selector: 'app-class-website',
  templateUrl: './class-website.component.html',
  styleUrls: ['./class-website.component.css']
})
export class ClassWebsiteComponent implements OnInit {


  public classWebsitesJson = ClassWebsitesJson;
  noData: any;
  

  constructor() { 
    
  }
  displayedColumns: string[] = ['semesterYear','grand', 'classNumber', 'siteName', 'siteUrl'];
  dataSource : MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  
  ngAfterViewInit() {
    
    this.dataSource = new MatTableDataSource(this.classWebsitesJson);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    
  }
  ngOnInit() {
    
  }

}
